import { useState } from "react";
import { wrapperRequests } from "../services/api";
import { routesURL } from "../services/routesUrl";
import { downloadFile, generateReportFileName } from "../shared/DownloadFile";

interface getAccountingSalesReportProps {
  startDate: string;
  endDate: string;
}

export function useAccountingSalesReport() {
  const [useAccountingSalesReportLoading, setUseAccountingSalesReportLoading] =
    useState(false);

  async function getAccountingSalesReport({
    startDate,
    endDate,
  }: getAccountingSalesReportProps) {
    setUseAccountingSalesReportLoading(true);

    try {
      const response = await wrapperRequests(
        routesURL.report.explore.getAccountingSalesReport,
        "POST",
        {
          data: {
            startDate,
            endDate,
          },
          responseType: "blob",
          timeout: 900000,
        },
      );

      downloadFile(response.data, {
        fileName: generateReportFileName("report"),
        mimeType: "text/csv",
      });
      setUseAccountingSalesReportLoading(false);
    } catch (error) {
      setUseAccountingSalesReportLoading(false);
      throw Error(String(error));
    }
  }
  return {
    getAccountingSalesReport,
    useAccountingSalesReportLoading,
  };
}
